import { put, takeEvery } from 'redux-saga/effects';

import * as TYPES from "../types";

import { ADD_ANNOUNCEMENT, ADD_BANNER, ADD_COLLABORATION, ADD_EVENT, ADD_KREPO, ADD_NEW_RESEARCH, ADD_PROJECT, ADD_TEAM_MEMBER, ADD_TEAM_TYPE, ADD_TRAINING, ADD_TRAINING_CATEGORY, ADD_UPCOMMING_PROJECT, ADD_VACANCIES, ANNOUNCEMENT_DELETE, BANNER_DELETE, COLLABORATION_DELETE, DELETE_RESEARCH_GALLERY_IMAGE, EVENT_DELETE, EVENT_IMAGE_DELETE, GET_ALL_ANNOUNCEMENT_LIST, GET_ALL_BANNER_LIST, GET_ALL_COLLABORATION_LIST, GET_ALL_EVENT_LIST, GET_ALL_KREPO_LIST, GET_ALL_PROJECT_LIST, GET_ALL_RESEARCH_LIST, GET_ALL_TEAM_MEMBER_LIST, GET_ALL_TEAM_TYPE_LIST, GET_ALL_TRAINING_CATEGORY_LIST, GET_ALL_TRAINING_LIST, GET_ALL_VACANCIES_LIST, KR_DELETE, PROJECT_DELETE, RESEARCH_DELETE, TEAM_MEMBER_DELETE, TEAM_TYPE_DELETE, TRAINING_CATEGORY_DELETE, TRAINING_DELETE, TRAINING_PDF_DELETE, UDPATE_COLLABORATION_STATUS, UPDATE_ANNOUNCEMENT_STATUS, UPDATE_BANNER_STATUS, UPDATE_EVENT_STATUS, UPDATE_KREPO_STATUS, UPDATE_RESEARCH_STATUS, UPDATE_TEAM_MEMBER_STATUS, UPDATE_TRAINING_STATUS, UPDATE_VACANCIES_STATUS, USER_SIGN_IN, VACANCIES_DELETE } from './Services';

import { userSignInSuccessAction } from '../Actions/AuthAction';
import { getAllResearchAction, getAllResearchSuccessAction } from '../Actions/ResearchAction';
import { loadingEndAction, loadingStartAction } from '../Actions/LoadingAction';
import { getAllProjectAction, getAllProjectSuccessAction } from '../Actions/ProjectAction';
import { getAllEventAction, getAllEventSuccessAction } from '../Actions/EventAction';
import { getAllTeamMemberAction, getAllTeamMemberSuccessAction, getAllTeamTypeAction, getAllTeamTypeSuccessAction } from '../Actions/TeamAction';
import { getAllCollaborationAction, getAllCollaborationSuccessAction } from '../Actions/CollaborationAction';
import { getAllKnowledgeRepositoryAction, getAllKnowledgeRepositorySuccessAction } from '../Actions/KnowledgeRepositoryAction';
import { getAllBannerAction, getAllBannerSuccessAction } from '../Actions/BannerAction';
import { getAllTrainingAction, getAllTrainingCategoryAction, getAllTrainingCategorySuccessAction, getAllTrainingSuccessAction } from '../Actions/TrainingAction';
import { getAllVacanciesAction, getAllVacanciesActionSuccessAction } from '../Actions/VacanciesActions';
import { getAllAnnouncementAction, getAllAnnouncementActionSuccessAction } from '../Actions/AnnouncementActions';

function* userSignIn(data) {
    try {
        const response = yield USER_SIGN_IN(data?.payload);

        if (response?.message === 'Login successful') {
            localStorage.setItem("dummy", response?.token)
            localStorage.setItem("dummyData", JSON.stringify(response))
            yield put(userSignInSuccessAction(response?.user));
            window.location.reload();
        } else {
            alert(response?.error)
        }

        // if (!response?.message) {
        //     console.error("USER SIGNIN ERROR Response Error")
        // } else {
        //     localStorage.setItem("dummy", response?.token)
        //     localStorage.setItem("dummyData", JSON.stringify(response))
        //     yield put(userSignInSuccessAction(response?.user));
        //     window.location.reload();
        // }

    } catch (error) {
        console.error("USER_SIGNIN_ERROR Error")
    }
}

function* getAllResearchList() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_RESEARCH_LIST();
        if (!response) {
            console.error("Get All Research Response Error")
        } else {
            yield put(getAllResearchSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Research Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addNewResearch(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_NEW_RESEARCH(data?.payload);

        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllResearchAction());
            // window.location.href = "/research";
            window.history.pushState({}, "", "/research");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteResearch(data) {
    try {
        yield put(loadingStartAction());
        const response = yield RESEARCH_DELETE(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllResearchAction());
            // window.location.href = "/research";
            window.history.pushState({}, "", "/research");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteResearchGalleryImage(data) {
    try {
        yield put(loadingStartAction());
        const response = yield DELETE_RESEARCH_GALLERY_IMAGE(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllResearchAction());
            window.history.pushState({}, "", "/research");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateResearchStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_RESEARCH_STATUS(data?.payload);

        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllResearchAction());
            window.history.pushState({}, "", "/research");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addProject(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_PROJECT(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllProjectAction());
            // window.location.href = "/projects/projectList";
            window.history.pushState({}, "", "/projects/projectList");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addUpcommingProject(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_UPCOMMING_PROJECT(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllProjectAction());
            window.history.pushState({}, "", "/projects/upcomingProjects");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllProjectList() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_PROJECT_LIST();
        if (!response) {
            console.error("Get All Research Response Error")
        } else {
            yield put(getAllProjectSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Research Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteProject(data) {
    try {
        yield put(loadingStartAction());
        const response = yield PROJECT_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Project Response")
        } else {
            yield put(getAllProjectAction());
            // window.location.href = "/projects/projectList";
            window.history.pushState({}, "", "/projects/projectList");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllEventList() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_EVENT_LIST();
        if (!response) {
            console.error("Get All Event Response Error")
        } else {
            yield put(getAllEventSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Event Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addEvent(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_EVENT(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllEventAction());
            window.history.pushState({}, "", "/events");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateEventStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_EVENT_STATUS(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllEventAction());
            window.history.pushState({}, "", "/events");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteEvent(data) {
    try {
        yield put(loadingStartAction());
        const response = yield EVENT_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Project Response")
        } else {
            yield put(getAllEventAction());
            // window.location.href = "/events";
            window.history.pushState({}, "", "/events");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteEventImage(data) {
    try {
        yield put(loadingStartAction());
        const response = yield EVENT_IMAGE_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Event Image Response")
        } else {
            yield put(getAllEventAction());
            window.history.pushState({}, "", "/events");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addTeamType(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_TEAM_TYPE(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllTeamTypeAction());
            window.history.pushState({}, "", "/about/teamCategory");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllteamTypeList() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_TEAM_TYPE_LIST();
        if (!response) {
            console.error("Get All Event Response Error")
        } else {
            yield put(getAllTeamTypeSuccessAction(response?.teams));
        }
    } catch (error) {
        console.error("Get All Event Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteTeamType(data) {
    try {
        yield put(loadingStartAction());
        const response = yield TEAM_TYPE_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Team type Response")
        } else {
            yield put(getAllTeamTypeAction());
            window.history.pushState({}, "", "/about/teamCategory");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addTeamMember(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_TEAM_MEMBER(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllTeamMemberAction());
            window.history.back()
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateTeamMemberStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_TEAM_MEMBER_STATUS(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllTeamMemberAction());
            window.history.back()
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllteamMemberList() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_TEAM_MEMBER_LIST();
        if (!response) {
            console.error("Get All Event Response Error")
        } else {
            yield put(getAllTeamMemberSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Event Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteTeamMember(data) {
    try {
        yield put(loadingStartAction());
        const response = yield TEAM_MEMBER_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Team type Response")
        } else {
            yield put(getAllTeamMemberAction());
            window.history.back()
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addCollaborationa(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_COLLABORATION(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllCollaborationAction());
            window.history.pushState({}, "", "/collaboration");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateCollaborationStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UDPATE_COLLABORATION_STATUS(data?.payload);
        if (!response) {
            console.error("Add New Research Response Error")
        } else {
            yield put(getAllCollaborationAction());
            window.history.pushState({}, "", "/collaboration");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllCollaborations() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_COLLABORATION_LIST();
        if (!response) {
            console.error("Get All Event Response Error")
        } else {
            yield put(getAllCollaborationSuccessAction(response?.collaborations));
        }
    } catch (error) {
        console.error("Get All Event Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteCollaboration(data) {
    try {
        yield put(loadingStartAction());
        const response = yield COLLABORATION_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Team type Response")
        } else {
            yield put(getAllCollaborationAction());
            window.history.pushState({}, "", "/collaboration");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Research  Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addKR(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_KREPO(data?.payload);
        if (!response) {
            console.error("Add New KR Response Error")
        } else {
            yield put(getAllKnowledgeRepositoryAction());
            window.history.pushState({}, "", "/knowledgeRepository");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateKRStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_KREPO_STATUS(data?.payload);
        if (!response) {
            console.error("Add New KR Response Error")
        } else {
            yield put(getAllKnowledgeRepositoryAction());
            window.history.pushState({}, "", "/knowledgeRepository");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllKR() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_KREPO_LIST();
        if (!response) {
            console.error("Get All KR Response Error")
        } else {
            yield put(getAllKnowledgeRepositorySuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All KR Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteKR(data) {
    try {
        yield put(loadingStartAction());
        const response = yield KR_DELETE(data?.payload);
        if (!response) {
            console.error("Delete KR type Response")
        } else {
            yield put(getAllKnowledgeRepositoryAction());
            window.history.pushState({}, "", "/knowledgeRepository");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add KR Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addBanner(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_BANNER(data?.payload);
        if (!response) {
            console.error("Add New KR Response Error")
        } else {
            yield put(getAllBannerAction());
            window.history.pushState({}, "", "/banners");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateBannerStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_BANNER_STATUS(data?.payload);
        if (!response) {
            console.error("Add New KR Response Error")
        } else {
            yield put(getAllBannerAction());
            window.history.pushState({}, "", "/banners");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Team Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllBanner() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_BANNER_LIST();
        if (!response) {
            console.error("Get All KR Response Error")
        } else {
            yield put(getAllBannerSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All KR Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteBanner(data) {
    try {
        yield put(loadingStartAction());
        const response = yield BANNER_DELETE(data?.payload);
        if (!response) {
            console.error("Delete KR type Response")
        } else {
            yield put(getAllBannerAction());
            window.history.pushState({}, "", "/banners");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add KR Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addTrainingCategory(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_TRAINING_CATEGORY(data?.payload);
        if (!response) {
            console.error("Add New Training Category Response Error")
        } else {
            yield put(getAllTrainingCategoryAction());
            window.history.pushState({}, "", "/training/category");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Training Category Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllTrainingCategory() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_TRAINING_CATEGORY_LIST();
        if (!response) {
            console.error("Get All Training Category Response Error")
        } else {
            yield put(getAllTrainingCategorySuccessAction(response?.categories));
        }
    } catch (error) {
        console.error("Get All Training Category Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteTrainingCategory(data) {
    try {
        yield put(loadingStartAction());
        const response = yield TRAINING_CATEGORY_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Training Category type Response")
        } else {
            yield put(getAllTrainingCategoryAction());
            window.history.pushState({}, "", "/training/category");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Delete Training Category Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addTraining(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_TRAINING(data?.payload);
        if (!response) {
            console.error("Add New Training Response Error")
        } else {
            yield put(getAllTrainingAction());
            window.history.pushState({}, "", "/allTraining");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateTrainingStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_TRAINING_STATUS(data?.payload);
        if (!response) {
            console.error("Add New Training Response Error")
        } else {
            yield put(getAllTrainingAction());
            window.history.pushState({}, "", "/allTraining");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllTraining() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_TRAINING_LIST();
        if (!response) {
            console.error("Get All Training Response Error")
        } else {
            yield put(getAllTrainingSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteTraining(data) {
    try {
        yield put(loadingStartAction());
        const response = yield TRAINING_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Training type Response")
        } else {
            yield put(getAllTrainingAction());
            window.history.pushState({}, "", "/allTraining");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Delete Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteTrainingPdf(data) {
    try {
        yield put(loadingStartAction());
        const response = yield TRAINING_PDF_DELETE(data?.payload);
        if (!response) {
            console.error("Delete KR type Response")
        } else {
            yield put(getAllBannerAction());
            window.history.pushState({}, "", "/allTraining");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add KR Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addVacancies(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_VACANCIES(data?.payload);
        if (!response) {
            console.error("Add Vacancies Response Error")
        } else {
            yield put(getAllVacanciesAction());
            window.history.pushState({}, "", "/contact/vacancies");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Vacancies Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllVacancies() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_VACANCIES_LIST();
        if (!response) {
            console.error("Get All Training Response Error")
        } else {
            yield put(getAllVacanciesActionSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteVacancies(data) {
    try {
        yield put(loadingStartAction());
        const response = yield VACANCIES_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Training type Response")
        } else {
            yield put(getAllVacanciesAction());
            window.history.pushState({}, "", "/contact/vacancies");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Delete Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateVacanciesStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_VACANCIES_STATUS(data?.payload);
        if (!response) {
            console.error("Add New Training Response Error")
        } else {
            yield put(getAllVacanciesAction());
            window.history.pushState({}, "", "/contact/vacancies");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* addAnnouncement(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ADD_ANNOUNCEMENT(data?.payload);
        if (!response) {
            console.error("Add Announcement Response Error")
        } else {
            yield put(getAllAnnouncementAction());
            window.history.pushState({}, "", "/announcements");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Announcement Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllAnnouncement() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_ANNOUNCEMENT_LIST();
        if (!response) {
            console.error("Get All Training Response Error")
        } else {
            yield put(getAllAnnouncementActionSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* deleteAnnouncement(data) {
    try {
        yield put(loadingStartAction());
        const response = yield ANNOUNCEMENT_DELETE(data?.payload);
        if (!response) {
            console.error("Delete Training type Response")
        } else {
            yield put(getAllAnnouncementAction());
            window.history.pushState({}, "", "/announcements");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Delete Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* updateAnnouncementStatus(data) {
    try {
        yield put(loadingStartAction());
        const response = yield UPDATE_ANNOUNCEMENT_STATUS(data?.payload);
        if (!response) {
            console.error("Add New Training Response Error")
        } else {
            yield put(getAllAnnouncementAction());
            window.history.pushState({}, "", "/announcements");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch (error) {
        console.error("Add Training Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* SagaData() {

    yield takeEvery(TYPES.SIGN_IN, userSignIn);

    yield takeEvery(TYPES.GET_ALL_RESEARCH, getAllResearchList);
    yield takeEvery(TYPES.ADD_RESEARCH, addNewResearch);
    yield takeEvery(TYPES.DELETE_RESEARCH, deleteResearch);
    yield takeEvery(TYPES.EDIT_RESEARCH, addNewResearch);
    yield takeEvery(TYPES.DELETE_RESEARCH_GALLERY_IMAGE, deleteResearchGalleryImage);
    yield takeEvery(TYPES.UPDATE_RESEARCH_STATUS_IMAGE, updateResearchStatus);

    yield takeEvery(TYPES.ADD_PROJECT, addProject);
    yield takeEvery(TYPES.GET_ALL_PROJECT, getAllProjectList);
    yield takeEvery(TYPES.DELETE_PROJECT, deleteProject);
    yield takeEvery(TYPES.EDIT_PROJECT, addProject);
    yield takeEvery(TYPES.ADD_UPCOMMING_PROJECT, addUpcommingProject);

    yield takeEvery(TYPES.GET_ALL_EVENT, getAllEventList);
    yield takeEvery(TYPES.ADD_EVENT, addEvent);
    yield takeEvery(TYPES.DELETE_EVENT, deleteEvent);
    yield takeEvery(TYPES.EDIT_EVENT, addEvent);
    yield takeEvery(TYPES.DELETE_EVENT_IMAGE, deleteEventImage);
    yield takeEvery(TYPES.UPDATE_EVENT_STATUS, updateEventStatus);

    yield takeEvery(TYPES.ADD_TEAM_TYPE, addTeamType);
    yield takeEvery(TYPES.GET_ALL_TEAM_TYPE, getAllteamTypeList);
    yield takeEvery(TYPES.DELETE_TEAM_TYPE, deleteTeamType);

    yield takeEvery(TYPES.ADD_TEAM_MEMBER, addTeamMember);
    yield takeEvery(TYPES.GET_ALL_TEAM_MEMBER, getAllteamMemberList);
    yield takeEvery(TYPES.DELETE_TEAM_MEMBER, deleteTeamMember);
    yield takeEvery(TYPES.EDIT_TEAM_MEMBER, addTeamMember);
    yield takeEvery(TYPES.UPDATE_TEAM_MEMBER_STATUS, updateTeamMemberStatus);

    yield takeEvery(TYPES.ADD_COLLABORATION, addCollaborationa);
    yield takeEvery(TYPES.GET_ALL_COLLABORATION, getAllCollaborations);
    yield takeEvery(TYPES.DELETE_COLLABORATION, deleteCollaboration);
    yield takeEvery(TYPES.EDIT_COLLABORATION, addCollaborationa);
    yield takeEvery(TYPES.UPDATE_COLLABORATION_STATUS, updateCollaborationStatus);

    yield takeEvery(TYPES.ADD_KR, addKR);
    yield takeEvery(TYPES.GET_ALL_KR, getAllKR);
    yield takeEvery(TYPES.DELETE_KR, deleteKR);
    yield takeEvery(TYPES.EDIT_KR, addKR);
    yield takeEvery(TYPES.UPDATE_KR_STATUS, updateKRStatus);

    yield takeEvery(TYPES.ADD_BANNER, addBanner);
    yield takeEvery(TYPES.GET_ALL_BANNER, getAllBanner);
    yield takeEvery(TYPES.DELETE_BANNER, deleteBanner);
    yield takeEvery(TYPES.EDIT_BANNER, addBanner);
    yield takeEvery(TYPES.UPDATE_BANNER_STATUS, updateBannerStatus);

    yield takeEvery(TYPES.ADD_TRAINING_CATEGORY, addTrainingCategory);
    yield takeEvery(TYPES.GET_ALL_TRAINING_CATEGORY, getAllTrainingCategory);
    yield takeEvery(TYPES.DELETE_TRAINING_CATEGORY, deleteTrainingCategory);

    yield takeEvery(TYPES.ADD_TRAINING, addTraining);
    yield takeEvery(TYPES.GET_ALL_TRAINING, getAllTraining);
    yield takeEvery(TYPES.DELETE_TRAINING, deleteTraining);
    yield takeEvery(TYPES.EDIT_TRAINING, addTraining);
    yield takeEvery(TYPES.UPDATE_TRAINING_STATUS, updateTrainingStatus);
    yield takeEvery(TYPES.DELETE_TRAINING_PDF, deleteTrainingPdf);

    yield takeEvery(TYPES.ADD_VACANCIES, addVacancies);
    yield takeEvery(TYPES.GET_ALL_VACANCIES, getAllVacancies);
    yield takeEvery(TYPES.EDIT_VACANCIES, addVacancies);
    yield takeEvery(TYPES.DELETE_VACANCIES, deleteVacancies);
    yield takeEvery(TYPES.UPDATE_VACANCIES_STATUS, updateVacanciesStatus);

    yield takeEvery(TYPES.ADD_ANNOUNCEMENT, addAnnouncement);
    yield takeEvery(TYPES.GET_ALL_ANNOUNCEMENT, getAllAnnouncement);
    yield takeEvery(TYPES.EDIT_ANNOUNCEMENT, addAnnouncement);
    yield takeEvery(TYPES.DELETE_ANNOUNCEMENT, deleteAnnouncement);
    yield takeEvery(TYPES.UPDATE_ANNOUNCEMENT_STATUS, updateAnnouncementStatus);

}

export default SagaData;